import { NEW_REDIRECT_ROUTE } from './AppRoute';
import { Environment } from './Environment';
import { LocalStorage } from './LocalStorage';
import { DataCenterCode, getDataCenter } from './Locales';

export const enableInternationalRedirect = (): boolean => {
  const isLocalHost = Environment.current.isLocalhost;
  const isNADataCenter = getDataCenter().code === DataCenterCode.NORTH_AMERICA;
  const isFlagSet = LocalStorage.tryGetItem(NEW_REDIRECT_ROUTE) === 'true';

  if (isNADataCenter && isFlagSet) {
    return true;
  }
  if (isLocalHost || (isNADataCenter && !isFlagSet)) {
    LocalStorage.trySetItem(NEW_REDIRECT_ROUTE, 'true');
    return true;
  }
  return false;
};
